import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { trigger, state, animate, transition, style, keyframes } from '@angular/animations';
import { BaseComponent } from './../base.component';
import { SharedService } from './../shared.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './../loader.service';
import { ValidationService } from '../../technician/technician-jobs/technician-common-validation';
import { TechnicianJobService } from '../..//technician/technician-jobs/technician-jobs.service';
import {
    EquipmentEntity, WoJobTaskDetails, JobPrintPre,
    JobDetailMaster, JobAppointMent, SpecialService, PrintPreview, Logo, Company
} from '../../technician/technician-jobs/technician-jobs.models';
import { PartRequestEntity, WoSLAHistory } from '../../work-order/work-order-models';
declare let jsPDF;
@Component({
    selector: 'job-print-preview-popup',
    templateUrl: 'print-preview.html',
    animations: [
        trigger('isVisibleChanged', [
            transition('void => *', [
                animate(600, keyframes([
                    style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ])
        ])
    ],
    styles: [`
    .m-dialog { width: 80%;margin: 30px auto;} 
    .hideScreen{display:none;} 
    #PrintPanel table > thead > tr > th, table > tbody > tr > th, table > tfoot > tr > th, table > thead > tr > td, table > tbody > tr > td, table > tfoot > tr > td {border-top: 0; } 
    #PrintPanel { font: 12px calibri;}  
    .s_formLabel {border: 1px solid #ccc;}
    .s_formLabel > tbody > tr{       
        border-bottom: 1px solid #ccc;
        color: #505050;      
    }
    .s_formLabel > tbody > tr > td{
        padding: 5px;
    }
    #printContainer tr th{
        background: #eeeeee !important;
        padding: 8px 0 !important;
        color: #4e4e4e !important;
        text-align: center;
       }
       .Tbl-Border{
        border: 1px solid #bfbfbf;
    }
    .main-heading h1{font-size:15px !important;}
    .SignatureTbl
    {
     border-top: 1px solid #ccc;
     padding: 5px 20px 0 20px;
     color: #4e4e4e;
     font-size: 13px;
    }
    .Tbl-Span
   {
    font-size: 12px;
    color: #484848;
   }
    `],
    encapsulation: ViewEncapsulation.None
})

export class JobPrintPreviewComponent extends BaseComponent implements OnInit {

    @Output() done = new EventEmitter();
    @Input() woJobId: number;
    @Input() CustomerId: number;
    @Input() TechId: number;
    @Input() WorkOrderId: number;
    @Input() woJobIdList: number[] = [];
    companyId: number;
    userId: number;
    equipmentEntity: EquipmentEntity[] = [];
    jobId: number;
    jobDetailMaster: JobDetailMaster;
    jobAppointMent: JobAppointMent;
    logo: Logo = new Logo();
    customerAndTechDetails: PrintPreview;
    JobPrintpreview: JobPrintPre[];
    customerAndTechDetailsList: PrintPreview[];
    jobDetailListTab: WoJobTaskDetails[] = [];
    specialInstruction: SpecialService[] = [];
    serviceNotes: SpecialService[] = [];
    technicianRemarksList: SpecialService[] = [];
    serviceNotesReason: any;
    specialInsstructionReason: any;
    displayName: string;
    company: Company = new Company();
    logoPrintout: Logo = new Logo();
    logoPrintoutHeader: Logo = new Logo();
    logoPrintoutFooter: Logo = new Logo();
    WoJobNo: string = "";
    partRequestEntity: PartRequestEntity[] = [];
    hoursStr: string;
    minStr: string;
    daysStr: string;
    woSLAhistory: WoSLAHistory[];
    woslahistory: WoSLAHistory;
    isVisible: boolean = false;
    signature1:boolean;
    signature2:boolean;
    signature3:boolean;
    constructor(protected sharedService: SharedService, protected translate: TranslateService,
        private _technicianJobService: TechnicianJobService, private datePipe: DatePipe, private loaderService: LoaderService) {
        super(sharedService, translate);

        this.companyId = super.globalInfo().CompanyId;
        this.userId = super.globalInfo().LoginId;
        this.customerAndTechDetails = new PrintPreview();
        this.customerAndTechDetailsList = [];
        this.woslahistory = new WoSLAHistory();
    }

    ngOnInit() {
        this.signature1 = this.translate.instant('SIGNATURE1') == "" ? false : true
        this.signature2 = this.translate.instant('SIGNATURE2') == "" ? false : true
        this.signature3 = this.translate.instant('SIGNATURE3') == "" ? false : true
        let jobIds = this.woJobIdList;
        if (this.woJobIdList.length == 0) {
            this.woJobIdList.push(this.woJobId);
            jobIds = this.woJobIdList;
        }
        this.getJobDetailsPrintPre(jobIds);

        this.printlogo(jobIds[0]);
    }   

    getJobDetailsPrintPre(wojob: number[]) {
        this.loaderService.show();
        this._technicianJobService.getWoJobDetailsPrint(this.companyId, wojob, this.WorkOrderId, this.TechId)
            .subscribe(s => {
                this.JobPrintpreview = s;
                this.loaderService.hide();
                this.JobPrintpreview.forEach(model => {
                    let f = model.CustomerTechDetail;
                    if (f != null) {
                        model.CustomerTechDetail = f;
                        model.CustomerTechDetail.TotalJobDuration = ValidationService.fullDayhourFormat(f.Days, f.Hours, f.Minutes);
                        model.CustomerTechDetail.TechDisplayName = f.TechDisplayName;
                        model.CustomerTechDetail.ServiceAddress = f.AddressLine1;
                        //
                        this.WoJobNo = f.WoJobId + "(" + f.WoNumber + ")";
                        model.CustomerTechDetail.WoJobId = model.JobDetail[0].WoJobId;
                        model.CustomerTechDetail.CreatedDate = this.datetimeFormat(f.CreatedDate);
                        model.CustomerTechDetail.ScheduleDate = this.datetimeFormat(f.ScheduleDate);
                        this.GetSpeciInstrAndServiNote(f.TimeZoneId, wojob[0]);
                        model.SlaHistoryEntity.map(x => {
                            x.CreatedDate = x.CreatedDate ? this.datePipe.transform(x.CreatedDate, 'short') : null;
                            x.ApptPrefDate = x.ApptPrefDate ? this.datePipe.transform(x.ApptPrefDate, 'short') : null;
                            x.SLAStartTime = x.SLAStartTime ? this.datePipe.transform(x.SLAStartTime, 'short') : null;
                            x.SLAEndTime = x.SLAEndTime ? this.datePipe.transform(x.SLAEndTime, 'short') : null;
                            x.ActualSLAEndTime = x.ActualSLAEndTime ? this.datePipe.transform(x.ActualSLAEndTime, 'short') : null;
                            x.Durationstr = this.durationCalc(x.Duration);
                        });
                    }
                    model.JobDetail = model.JobDetail.map(m => {
                        m.HourAndMinutes = ((m.Hours !== null && +m.Hours !== 0) ? m.Hours + ' hr ' : '') + ((m.Minutes !== null && +m.Minutes !== 0) ? m.Minutes + ' mins' : '');
                        m.CompanyId = this.companyId;
                        return m;
                    });
                });
                
            }, e => { this.loaderService.hide(); });
    }

    durationCalc(val: number) {
        if (val <= 0)
            return "";
        var comStr = "";
        var hrs = 0;
        var days = 0;
        var i = 0, j = 0;
        if (val < 60) {
            comStr = 0 + " " + this.hoursStr + " " + val + " " + this.minStr;
            return comStr;
        }

        for (i = 60; i <= val;) {
            hrs = hrs + 1;
            i = i + 60;
        }
        i = i - 60;
        if (hrs >= 24) {
            for (j = 24; j <= hrs;) {
                days = days + 1;
                j = j + 24;
            }
            j = j - 24;
            comStr = days + " " + this.daysStr + " " + (hrs - j) + " " + this.hoursStr + " " + (val - i) + " " + this.minStr;
        }
        else
            comStr = hrs + " " + this.hoursStr + " " + (val - i) + " " + this.minStr;
        return comStr;
    }

    GetSpeciInstrAndServiNote(TechTimeZoneid: number, wojob: number): void {
        this.specialInstruction = [];
        this.serviceNotes = [];
        this.technicianRemarksList = [];
        this.loaderService.show();//this.woJobId
        this._technicianJobService.GetSpeciInstrAndServiNote(this.companyId, wojob, this.userId, TechTimeZoneid, this.CustomerId, this.WorkOrderId)
            .subscribe(s => {
                this.loaderService.hide();
                this.displayName = s.DisplayName;
                this.specialInstruction = s.GetWojobSplInsDetails;
                this.serviceNotes = s.GetWojobServiceNotesDetails;
                this.technicianRemarksList = s.GetWojobTechnicialRemark;
                this.technicianRemarksList.map(x => {
                    x.CreateAndUpdateDate = x.CreatedDate ? this.datetimeFormat(x.CreatedDate) : null;
                });

                if (this.serviceNotes.length != 0)
                    this.serviceNotesReason = this.serviceNotes[this.serviceNotes.length - 1].Note;
                if (this.specialInstruction.length != 0)
                    this.specialInsstructionReason = this.specialInstruction[this.specialInstruction.length - 1].Note;

            });
    }

    datetimeFormat(dateTimeVal: any): any {
        if (dateTimeVal == "0001-01-01T00:00:00" || dateTimeVal == "" || dateTimeVal == null || dateTimeVal == "1/1/0001 12:00:00 AM")
            return "";
        else
            return this.datePipe.transform(dateTimeVal, 'shortDate') + " " + this.datePipe.transform(dateTimeVal, 'shortTime')
    }

    closePopup() {
        this.done.emit();
    }

    printlogo(wojob: number) {
        this._technicianJobService.getCompany(this.companyId).subscribe(cus => {
            this.company = cus;
            if (this.company.PrintoutLogoPath != "" || this.company.PrintoutLogoPath != null || this.company.PrintoutLogoPath != null) {
                this._technicianJobService.GetPrintoutLogo(this.companyId, this.company.PrintoutLogoPath).subscribe(res => {
                    this.logoPrintout = res;
                });
            }

            if (this.company.PrintoutHeaderPath != "" || this.company.PrintoutHeaderPath != null || this.company.PrintoutHeaderPath != null) {
                this._technicianJobService.GetPrintoutHeader(this.companyId, this.company.PrintoutHeaderPath).subscribe(res => {
                    this.logoPrintoutHeader = res;
                });
            }

            if (this.company.PrintOutFooterPath != "" || this.company.PrintOutFooterPath != null || this.company.PrintOutFooterPath != null) {
                this._technicianJobService.GetPrintoutFooter(this.companyId, this.company.PrintOutFooterPath).subscribe(res => {
                    this.logoPrintoutFooter = res;
                });
            }
        });
    }

    Print(): void {
        let popupWinindow: any;
        let innerContents: any = document.getElementById('printArea').innerHTML;
        let themeClass = document.body.getAttribute("class");
        popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        // setTimeout(window.close, 5);
        popupWinindow.document.write('<html><head><title>JobDetails</title>	<link rel="stylesheet" href="/assets/css/zylog-skin.css"><link rel="stylesheet" href="/assets/css/zylog-print.css"></head><body id="wrapper" class="' + themeClass + '" onload="window.print();setTimeout(window.close, 5);">' + innerContents + '</body></html>');
        popupWinindow.document.close();
    }
}